const SessionStorageService = {
  get<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  },

  set<T>(key: string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  },

  clear: (): void => sessionStorage.clear(),

  remove: (key: string): void => sessionStorage.removeItem(key),
};

export default SessionStorageService;
